'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Validator = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _reactIntl = require('react-intl');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  required: {
    id: 'payment.validations.genericRequired',
    defaultMessage: 'This field is required.'
  }
});

var Validator = exports.Validator = function Validator(data) {
  var errors = {};

  if ((0, _keys2.default)(data).indexOf('ccName') !== -1 && (0, _verify.isBlank)(data.ccName)) {
    errors.ccName = messages.required;
  }

  return errors;
};